import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Backdrop = React.forwardRef(function Backdrop({ isOpen, isInvisible, ...props }, ref) {
  return isOpen ? <Root isInvisible={isInvisible} aria-hidden ref={ref} {...props} /> : null;
});

Backdrop.displayName = 'Backdrop';

Backdrop.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isInvisible: PropTypes.bool
};

const Root = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${props => (props.isInvisible ? 'transparent' : 'rgba(0, 0, 0, 0.3)')};
  -webkit-tap-highlight-color: transparent;
  touch-action: none;
  z-index: -1;
`;

export default Backdrop;
